/** Evergreen storefront products (seeded / linked as Merch.group_id). */

export const MERCH_HUB_HREF = "/merch";
export const MERCH_HUB_TITLE = "Merch!";
export const MERCH_HUB_EYEBROW = "Shop";
/** Flip on, migrate 0138, and deploy to sell the Katz's hat and shirt. */
export const KATZ_MERCH_LIVE = true;
export const MERCH_HUB_BLURB = KATZ_MERCH_LIVE
  ? "ComedyUO hat and Katz's pastrami merch. Ships to you."
  : "ComedyUO hat · Ships to you.";

export const DAD_HAT_GROUP_ID = "comedy-uo-dad-hat";
/** @deprecated Prefer MERCH_HUB_HREF; kept for old /merch/comedy-uo-dad-hat links. */
export const DAD_HAT_HREF = MERCH_HUB_HREF;
/** Red "Comedy In Strange Places" hat (show-assets merch upload). */
export const DAD_HAT_IMG =
  "https://storage.googleapis.com/cuo-show-assets/merch/5ad1c9d8-b08b-4c83-a161-3c2cf8d91547.png";
export const KATZ_HAT_GROUP_ID = "katz-pastrami-hat";
export const KATZ_HAT_IMG =
  "https://storage.googleapis.com/cuo-website/Pastrami%20Comedy%20Hat.png";
export const KATZ_HAT_TITLE = "Katz's Pastrami Comedy Hat";
export const KATZ_HAT_BLURB = "One size · $30";

export const KATZ_SHIRTS_GROUP_ID = "katz-pastrami-shirts";
export const KATZ_SHIRTS_IMG =
  "https://storage.googleapis.com/cuo-website/Pastrami%20Comedy%20Shirts.png";
export const KATZ_SHIRTS_TITLE = "Katz's Pastrami Comedy Shirt";
export const KATZ_SHIRTS_BLURB = "XS–XL · $30";
export const KATZ_SHIRT_SIZES = ["XS", "S", "M", "L", "XL"] as const;
export const DAD_HAT_TITLE = "ComedyUO Hat";
export const DAD_HAT_EYEBROW = "The Official Hat";
export const DAD_HAT_BLURB = "Embroidered · One size · $30";
